import React from "react";
import { Well } from "react-bootstrap";

export const LoadingIndicator = () => (
  <Well>
    <h4>Loading...</h4>
  </Well>
);
